import { render, staticRenderFns } from "./SubgroupsSettings.vue?vue&type=template&id=68ec581a&scoped=true"
import script from "./SubgroupsSettings.vue?vue&type=script&lang=js"
export * from "./SubgroupsSettings.vue?vue&type=script&lang=js"
import style0 from "./SubgroupsSettings.vue?vue&type=style&index=0&id=68ec581a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ec581a",
  null
  
)

export default component.exports